import React from "react";
import { CardWrapper } from "./style";
import { useQuery } from "react-query";
import { formatDate } from "@website-builder/utilities-index";
import { getProgramInfo } from "@website-builder/services";

const ProgramDetailsCard = ({ format, duration, shortName, programName }) => {
	const {
		data: programInfo = [],
		error,
		isLoading,
	} = useQuery(
		["Program", programName],
		getProgramInfo(shortName, programName),
	);
	if (error) {
		console.error("Program Details Card: Error while loading data", error);
	}
	const { content = {} } = programInfo;
	const { next_date_string = "", application_deadline = "" } = content;
	const cohortCutOffDate = formatDate(application_deadline, "MMM d, y");
	return (
		<CardWrapper>
			<div>
				<strong>Format</strong>
				{` ${format}`}
			</div>
			<hr />
			<div>
				<strong>Duration</strong>
				{` ${duration}`}
			</div>
			<hr />
			<div>
				<strong>Apply by</strong>
				{` ${cohortCutOffDate}. Cohort starts ${next_date_string}.`}
			</div>
		</CardWrapper>
	);
};

export default ProgramDetailsCard;
